import React from 'react'
import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { ContactDataGetContactDetailsQuery } from '@agtech/data/contacts/ContactDataQueries';
import { getContactFullName } from '@agtech/data/contacts/ContactData';
import ContactNotesGrid from '../../components/grids/ContactNotesGrid';
import ContactNoteDialog from './ContactNoteDialog';

export type ContactNotesViewDialogProps = {
    contactId: number
}

const ContactNotesViewDialog = (props: ContactNotesViewDialogProps) => {
    const getContactDetailsQuery = useAgTechQuery({
        query: ContactDataGetContactDetailsQuery,
        queryContext: {
            contactId: props.contactId
        }
    });

    return (
        <AgTechViewDialog
            data={{
                query: getContactDetailsQuery
            }}
            structure={{
                header: contactDetails => ({
                    header: 'Notes - ' + getContactFullName(contactDetails.contact),
                    detail: "Below are all active notes for this contact"
                }),
                width: "800px"
            }}
        >
            {(contactDetails) => (
                <div className='stretched p-body flex'>
                    <ContactNotesGrid
                        contactId={props.contactId}
                        notes={Object.values(contactDetails.notes)}
                        gridProps={contactGridProps => {
                            return {
                                ...contactGridProps,
                                header: {
                                    title: 'Notes',
                                    content: () => (
                                        <ContactNoteDialog.Button
                                            contactId={props.contactId}
                                        />
                                    )
                                },
                                searchConfig: {
                                    options: [
                                        { field: 'Date', value: note => new Date(note.date).toDateString() },
                                        { field: 'Note', value: note => note.note }
                                    ]
                                }
                            }
                        }}
                    />
                </div>
            )}
        </AgTechViewDialog>
    );
}

ContactNotesViewDialog.Open = (e: AgTechClickEventHandler, props: ContactNotesViewDialogProps) => e.dialogs.openDialog({
    dialog: () => <ContactNotesViewDialog {...props} />
});

ContactNotesViewDialog.Button = (props: ContactNotesViewDialogProps & AgTechButtonProps) => (
    <AgTechButton
        text='View notes'
        icon='fas fa-eye'
        {...props}
        action={e => ContactNotesViewDialog.Open(e, props)}
    />
);

export default ContactNotesViewDialog;